<template>
    <form method='POST' v-on:submit.prevent="handleSubmit">
        <div class='m-portlet__body'>
            <div class='m-form__section'>
                <div class='m-form__heading'>
                    <h3 class='m-form__heading-title'>
                        Middleware Settings
                    </h3>
                </div>
                <div class='form-group m-form__group row'>
                    <div class='col-lg-6 m-form__group-sub'>
                        <label class='form-control-label'>
                            * Middlewares:
                        </label>
                        <div class='m-checkbox-inline'>
                            <label class='m-checkbox' v-for='(value) in middlewares'
                                   v-bind:key='value'>
                                <input type='checkbox' :id="value" :value='value' v-model="form">
                                {{value}}
                                <span></span>
                            </label>
                        </div>
                        <span class='m-form__help'>
                                                            Please select user group
                                                         </span>
                    </div>
                </div>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/modules/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
export default {
  name: 'ModuleUpdateMiddleware',
  components: {Buttons},
  data () {
    return {
      middlewares: [],
      form: []
    }
  },
  methods: {
    handleSubmit () {
      this.$http
        .put(process.env.API_URL + `/api/v1/admin/module-builder/update-middleware`, {
          middlewares: this.form,
          moduleName: this.$route.params.id
        }, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            this.$router.push('/admin/modules/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  mounted: function () {
    this.$emit('updateTitle', 'Update Middlewares: ' + this.$route.params.id)

    let self = this
    this.$http
      .get(process.env.API_URL + '/api/v1/admin/settings/get-middlewares', {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.middlewares = res.data.data

        this.$http
          .get(process.env.API_URL + `/api/v1/admin/module-builder/show/${this.$route.params.id}`, {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': this.$store.state.loading.language
            }
          }).then(res => {
            this.form = res.data.data.middlewares
          })
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleUpdateMiddleware.vue